(function($){
 $(function(){
   var headerHeight = 200;

   $(window).scroll(function() {
     var scrolled = $(document).scrollTop();
     if (scrolled > headerHeight){
       $('.primary-nav').addClass('default-state');
       $('.secondary-nav').addClass('default-state');
       $('.icon-bag').addClass('default-state');
       $('.icon-account').addClass('default-state');
       $('.burger').addClass('default-state');
     } else {
       $('.primary-nav').removeClass('default-state');
       $('.secondary-nav').removeClass('default-state');
       $('.icon-bag').removeClass('default-state');
       $('.icon-account').removeClass('default-state');
       $('.burger').removeClass('default-state');
     }
   });
 });
})(jQuery);